import cn from 'classnames';
import { identity } from 'fp-ts/lib/function';
import * as React from 'react';
import { Fragment } from 'react';
import style from './Mentions.module.scss';
export var Mention = function (props) {
    return React.createElement("span", { className: cn(style.mention, props.className) },
        "@",
        props.text);
};
var defaultRenderText = identity;
var mentionRegexp = /@\[([^\]]+)\]\(\d+\)/;
export var TextWithMentions = function (props) {
    var _a = props.renderText, renderText = _a === void 0 ? defaultRenderText : _a;
    return (React.createElement(Fragment, null, parseTextToMentionTokens(props.text).map(function (token, i) {
        switch (token.type) {
            case 'raw':
                return React.createElement(Fragment, { key: i }, renderText(token.text));
            case 'mention':
                return React.createElement(Mention, { className: props.className, text: token.text, key: i });
        }
        return undefined;
    })));
};
export function parseTextToMentionTokens(original) {
    var tokens = [];
    var match;
    var text = original;
    while ((match = mentionRegexp.exec(text))) {
        if (match.index > 0) {
            tokens.push({ type: 'raw', text: text.substring(0, match.index) });
        }
        tokens.push({ type: 'mention', text: match[1] });
        text = text.substring(match.index + match[0].length);
    }
    if (text.length) {
        tokens.push({ type: 'raw', text: text });
    }
    return tokens;
}
//# sourceMappingURL=Mentions.js.map